import styled from 'styled-components';
import { Popover } from '../../../popovers';

export const StyledPopover = styled(Popover)`
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;
`;

export const PopoverContent = styled.div`
    span {
      font-weight: 500;
    }
`;



// WEBPACK FOOTER //
// ./src/components/attachments/header/information/styled-components.js